import * as React from "react";

import { StaticImage } from 'gatsby-plugin-image';
import Layout from '../components/layout';
import { about, content, contentFlex, image, instagram } from './index.module.scss';

import { Link } from "gatsby";
import { FaInstagram } from "react-icons/all";
import BottomSpace from "../components/bottomSpace";

import Zoom from '../components/Zoom';

const IndexPage = () => {
    return (
        <Layout pageTitle="Hem" largeHero={true}>
            <div className={content}>
                {/*                 <div className={puppies}>
                    <p>
                        🐾🐾 Pudelvalpar födda, hanar letar hem 🐾🐾
                    </p>
                </div> */}
                <div className={contentFlex}>
                    <div className={about}>
                        <h1>Om Kenneln</h1>
                        <p>
                            Välkommen hit! Jag heter Louise Amsen och har alltid haft hund under min uppväxt. Intresset för avel började 2018 när jag skaffade min första pudel Juni. Strax därefter flyttade Java in, min första shetland sheepdog och sen har det tillkommit flera stjärnor i våran familj. För mig ligger hälsa i störst fokus, jag vill få fram härliga familjehundar som kan fungera i alla olika miljöer. Jag hälsotestar såklart alla mina hundar efter rasklubbarnas rekommendationer och önskar ha fortsatt kontakt med alla valpköpare och vara ett bollplank för högt och lågt genom hundarnas liv.
                        </p>
                        <p>
                            Jag började med agility 2025 och tycker att det är en otroligt rolig hundsport. Min tanke och filosofi är att hela tiden sträva mot ett roligt liv med hund där inget ska kännas "jobbigt" eller som ett måste. Och jag vill att mina hundar ska ha den så kallade "av och på" knappen vilket innebär att de kan varva ner och inte bli stressade av en lugn period utan intensiv träning dagligen.
                        </p>
                        <p>
                            Kennelnamnet Sagotassens registrerades och godkändes 2021. Året 2022 genomförde jag SKKs uppfödarutbildning och följer därmed Svenska Kennelklubbens regler och riktlinjer som utgår ifrån centrala bestämmelser kring hundhållning, avel och uppfödning. Här är hundarna en naturlig del av vår familj och de perioder vi har valpkull så föds de upp i hemmiljö med en stor dos av gos och kärlek från alla i familjen, både tvåbenta och fyrbenta.
                        </p>
                    </div>

                    <Zoom wrapperClass={image}>
                        <StaticImage loading="eager" src={'../images/icon.png'} alt={"En av våra valpar!"} />
                    </Zoom>

                </div>

                <Link to={"https://www.instagram.com/sagotassenskennel/"} style={{ paddingLeft: "5%", paddingRight: "5%", marginTop: "36px", display: "flex", justifyContent: "center", color: "#000" }}>
                    <FaInstagram className={instagram} />
                    <h3 style={{ margin: 0, marginLeft: "16px", alignSelf: "center" }}>Följ oss på Instagram</h3>
                </Link>
            </div>

            <BottomSpace />
        </Layout>
    )
}

export default IndexPage
